export const extractBarkToken = (input) => {
  if (!input) return '';

  const trimmed = input.trim();
  const parts = trimmed.split('/');

  for (let i = parts.length - 1; i >= 0; i--) {
    const part = parts[i].trim();
    if (part && part !== 'https:' && part !== 'http:') {
      return part;
    }
  }

  return trimmed;
};
